export default __webpack_public_path__ + "static/media/WO_GIBTS_WAS.324abffc.png";